import { Badge } from "@/components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, Clock, FilePlus } from "lucide-react";
import { NovasInscricoesList, DocumentosPendentesList, OtpsExpirandoList } from "@/components/alerts/AlertLists";

function CountBadge({ count, color }) {
  if (!count) return null;
  return (
    <Badge className={`h-4 min-w-[16px] px-1 ${color} text-white text-[9px]`}>{count}</Badge>
  );
}

export function AlertsTabs({ data, seenAt, novasCount, docsCount, otpsCount, onOpen }) {
  return (
    <Tabs defaultValue="novas">
      <TabsList className="w-full rounded-none grid grid-cols-3 bg-white border-b">
        <TabsTrigger value="novas" data-testid="tab-novas" className="text-xs gap-1">
          <FilePlus className="w-3.5 h-3.5" /> Novas <CountBadge count={novasCount} color="bg-red-500" />
        </TabsTrigger>
        <TabsTrigger value="docs" data-testid="tab-docs" className="text-xs gap-1">
          <FileText className="w-3.5 h-3.5" /> Docs <CountBadge count={docsCount} color="bg-amber-500" />
        </TabsTrigger>
        <TabsTrigger value="otps" data-testid="tab-otps" className="text-xs gap-1">
          <Clock className="w-3.5 h-3.5" /> OTPs <CountBadge count={otpsCount} color="bg-red-500" />
        </TabsTrigger>
      </TabsList>

      <TabsContent value="novas" className="m-0 max-h-[360px] overflow-y-auto">
        <NovasInscricoesList items={data?.novas?.items || []} seenAt={seenAt} onOpen={onOpen} />
      </TabsContent>
      <TabsContent value="docs" className="m-0 max-h-[360px] overflow-y-auto">
        <DocumentosPendentesList items={data?.documentos_pendentes?.items || []} onOpen={onOpen} />
      </TabsContent>
      <TabsContent value="otps" className="m-0 max-h-[360px] overflow-y-auto">
        <OtpsExpirandoList items={data?.otps_expirando?.items || []} onOpen={onOpen} />
      </TabsContent>
    </Tabs>
  );
}
